import React from "react";

const Button = ({ active, onClick, text, color = "red" }) => (
	<button
		className={`c-btn c-btn--${color} ${
			active && "c-btn--outline"
		} d-flex flex-grow-1 mx-1 py-2`}
		onClick={onClick}
	>
		{text}
	</button>
);

export default Button;
